import { Component, viewChild } from '@angular/core';
import {
  PopoverComponent,
  Button,
  SimplePopoverLayout,
  SimpleDialog,
  SimpleDialogLayout,
} from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { FeatureEnabledDirective } from '../../../../shared/directives/feature-enabled';
import { environment } from '../../../../../environments/environment';
import { YoutubeEmbed } from '../../../../shared/components/youtube-embed/youtube-embed';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-tutorial-locations-popover',
  imports: [
    PopoverComponent,
    NgIcon,
    Button,
    SimplePopoverLayout,
    SimpleDialog,
    SimpleDialogLayout,
    FeatureEnabledDirective,
    YoutubeEmbed,
    TranslocoPipe,
  ],
  templateUrl: './tutorial-locations-popover.html',
})
export class TutorialLocationsPopover {
  private tutorialPopover = viewChild<PopoverComponent>('tutorialPopover');

  protected embedVideoUrl = environment.tutorialVideoEmbedLinks.locations;

  showPopover() {
    this.tutorialPopover()?.show();
  }
}
